import React, { useEffect } from 'react';
import { Text, TextVariant } from '@naf/text';
import { Tag } from '@naf-simba/elements-tag';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CenterProducts } from '@appTypes/centerArticleType';
import useSelector from '@redux/typedHooks';
import { useAuth0Token } from '@hooks/useAuth0Token';
import { actions as MyMembershipActions } from '@redux/modules/myMembership';
import { nafCenterBasePath } from '../../../../routers/NafCenterRouter';
import BookingButton from './BookingButton';
import S from '../styles';

export const NafCenterProduct = ({
  ingress,
  memberPrice,
  name,
  nonMemberPrice,
  booking,
  bookingText,
  isBeta,
  isNew,
  isForMembersOnly,
  link,
  linkText,
  centerId,
  internalProductId,
}: CenterProducts) => {
  const dispatch = useDispatch();
  const { simpleToken } = useAuth0Token();
  const customerInformation = useSelector((state) => state.myMembership.customerInformation.data);

  useEffect(() => {
    if (simpleToken && !customerInformation) {
      dispatch(MyMembershipActions.getCustomerInformation.request(simpleToken));
    }
  }, [simpleToken, dispatch, customerInformation]);

  return (
    <S.ProductRow key={name}>
      <S.ProductInfo>
        <S.ProductHeader>
          <Text variant={TextVariant.Header3}>{name}</Text>
          {((memberPrice && memberPrice.isCampaign) || (nonMemberPrice && nonMemberPrice.isCampaign)) && (
            <Tag color="secondary" shade="light" text="Kampanje" />
          )}
          {isNew && <Tag color="secondary" shade="light" text="Nyhet" />}
          {isBeta && <Tag color="information" text="Beta" />}
          {isForMembersOnly && <Tag color="primary" text="Medlemseksklusivt" />}
        </S.ProductHeader>
        <Text variant={TextVariant.BodyText}>{ingress}</Text>
        {link && link.data && link.type === 'internalLink' && (
          <Link to={`/${nafCenterBasePath}/${link.data.slug}`}>
            <Text variant={TextVariant.BodyText}>{linkText || `Les mer om ${name}`}</Text>
          </Link>
        )}
      </S.ProductInfo>
      <S.OrderProduct>
        {memberPrice &&
          (memberPrice.isCampaign && memberPrice.campaignPrice ? (
            <S.PriceRow>
              <Text variant={TextVariant.Header3}>{memberPrice.campaignPrice},- </Text>
              {memberPrice.price && (
                <S.OrdinaryPrice variant={TextVariant.Header3}>{memberPrice.price},-</S.OrdinaryPrice>
              )}
            </S.PriceRow>
          ) : (
            memberPrice.price && <Text variant={TextVariant.Header3}>{memberPrice.price},-</Text>
          ))}
        {memberPrice &&
          nonMemberPrice &&
          (nonMemberPrice.isCampaign && nonMemberPrice.campaignPrice ? (
            <S.PriceRow>
              <S.NonMemberPrice variant={TextVariant.BodyTextHeader}>Ikke-medlem</S.NonMemberPrice>
              <S.NonMemberCampaign>
                <S.NonMemberPrice variant={TextVariant.BodyTextHeader}>
                  {nonMemberPrice.campaignPrice},-{' '}
                </S.NonMemberPrice>
                {nonMemberPrice.price && (
                  <S.OrdinaryPrice variant={TextVariant.BodyTextHeader}>{nonMemberPrice.price},-</S.OrdinaryPrice>
                )}
              </S.NonMemberCampaign>
            </S.PriceRow>
          ) : (
            nonMemberPrice.price && (
              <S.NonMemberPrice variant={TextVariant.BodyTextHeader}>
                Ikke-medlem {nonMemberPrice.price},-
              </S.NonMemberPrice>
            )
          ))}
        {!memberPrice &&
          nonMemberPrice &&
          (nonMemberPrice.isCampaign && nonMemberPrice.campaignPrice ? (
            <S.PriceRow>
              <Text variant={TextVariant.Header3}>{nonMemberPrice.campaignPrice},- </Text>
              {nonMemberPrice.price && (
                <S.OrdinaryPrice variant={TextVariant.Header3}>{nonMemberPrice.price},-</S.OrdinaryPrice>
              )}
            </S.PriceRow>
          ) : (
            nonMemberPrice.price && <Text variant={TextVariant.Header3}>{nonMemberPrice.price},-</Text>
          ))}
        <BookingButton
          booking={booking}
          bookingText={bookingText}
          link={link}
          centerId={centerId}
          internalProductId={internalProductId}
        />
      </S.OrderProduct>
    </S.ProductRow>
  );
};
